import { TableHead as MuiTableHead, TableHeadProps as MuiTableHeadProps } from '@mui/material'
import styled from 'styled-components'

export type TableHeadPropsType = MuiTableHeadProps

const TableHead = styled(MuiTableHead)<TableHeadPropsType>``
export default TableHead
